import React from 'react';
import styles from './index.module.scss';

const Balance = () => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width='26' height='26' viewBox='0 0 26 26'>
            <defs>
                <linearGradient id='a' x1='0.5' x2='0.5' y2='1' gradientUnits='objectBoundingBox'>
                    <stop offset='0' stopColor='#ea2c2f' />
                    <stop offset='1' stopColor='#8e0003' />
                </linearGradient>
            </defs>
            <g transform='translate(-84.25 6.125)'>
                <rect
                    width='26'
                    height='26'
                    rx='5.366'
                    transform='translate(84.25 -6.125)'
                    fill='url(#a)'
                />
                <g transform='translate(88.649 -2.146)'>
                    <g transform='translate(-0.399 7.021)'>
                        <rect width='2.077' height='12' rx='1.038' fill='#ff797b' />
                        <g transform='translate(3.981 3.434)'>
                            <rect width='2.077' height='8.566' rx='1.038' fill='#ff797b' />
                        </g>
                        <g transform='translate(7.962 5.168)'>
                            <rect width='2.077' height='6.832' rx='1.038' fill='#ff797b' />
                        </g>
                        <g transform='translate(11.942 3.434)'>
                            <rect width='2.077' height='8.566' rx='1.038' fill='#ff797b' />
                        </g>
                        <g transform='translate(15.923)'>
                            <rect width='2.077' height='12' rx='1.038' fill='#ff797b' />
                        </g>
                    </g>
                    <g transform='translate(4.601 0.021)'>
                        <circle cx='4' cy='4' r='4' transform='translate(0 0)' fill='#ff797b' />
                        <path
                            d='M209.965,417.182v-1.191a1.347,1.347,0,0,0-1.008-1.273l-.1-.028v1.7l-.6.145V414.69l-.1.028a1.347,1.347,0,0,0-1.008,1.273v1.191h-.6v-1.191a1.92,1.92,0,0,1,1.639-1.858l.063-.011v-.395l.6-.145v.54l.063.011a1.92,1.92,0,0,1,1.639,1.858v1.191Z'
                            transform='translate(-204.56 -411.582)'
                            fill='#8e0003'
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default Balance;
